import { useTranslation } from 'react-i18next';
import ErrorViewer from '../../../../../../common/widgets/ErrorViewer';
import { ValidationError } from '../../../../../benefit/models/Errors';
import { resources } from '../../../../resources/resources';
import { CodeSources } from '../Codes/utils';

interface CodesSourceSelectorProps {
  codesSource?: CodeSources;
  onChange: (codesSource: CodeSources) => void;
  errors?: ValidationError[];
}

export const CodesSourceSelector = (props: CodesSourceSelectorProps) => {
  const { t: translate } = useTranslation();
  const { codesSource, onChange, errors } = props;

  const setGenerated = () => {
    if (codesSource === CodeSources.Generated) return;
    onChange(CodeSources.Generated);
  };

  const setManuallyAdded = () => {
    if (codesSource === CodeSources.ManuallyAdded) return;
    onChange(CodeSources.ManuallyAdded);
  };

  return (
    <>
      <div className="form-options-list">
        <ul
          role="radiogroup"
          className="k-radio-list k-list-horizontal"
          dir="ltr"
        >
          <li className="k-radio-item" role="none">
            <input
              type="radio"
              className="k-radio k-radio-md"
              checked={codesSource === CodeSources.Generated}
              onChange={setGenerated}
            />
            <label className="k-radio-label" onClick={setGenerated}>
              {translate(resources.codes.generate.label)}
            </label>
          </li>
          <li className="k-radio-item" role="none">
            <input
              type="radio"
              className="k-radio k-radio-md"
              checked={codesSource === CodeSources.ManuallyAdded}
              onChange={setManuallyAdded}
            />
            <label className="k-radio-label" onClick={setManuallyAdded}>
              {translate(resources.codes.addManually.label)}
            </label>
          </li>
        </ul>
      </div>
      <ErrorViewer errors={errors} />
    </>
  );
};
